export const incentiveRegisterSave = `mutation IncentiveRegisterSave($incentiveRegister: IncentiveRegisterInput!)
{
    incentiveRegisterSave(incentiveRegister:$incentiveRegister)
    {
        successful
        errors { message }
    }
}`